<template>
<div ref="dummy"
     class="odr-sticky-dummy"
     :class="{'odr-sticky-dummy_stretched': stretched}">
    <div ref="sticky"
         class="odr-sticky"
         :class="{'odr-sticky_fixed': fixed,
                  'odr-sticky_stretched': stretched,
                  'odr-sticky_bottom': fixed && onBottom}">
        <slot/>
    </div>
</div>
</template>

<script>
import '@/scss/blocks/sticky.scss';

import sticky from '@/utils/sticky';
import { mapState } from 'vuex';

export default {
    props: {
        stickyArea: {
            required: true,
        },
        zIndex: {
            type: Number,
            default: 1,
        },
        addFixedTop: {
            type: Number,
            default: 0,
        },
        stretched: {},
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            fixed: false,
            onBottom: false,
            width: '100%',
            height: 'auto',
            stickyAreaElement: null,
            tick: true,
            forceRecompute: 0,
            stickyAreaBottom: 0,
            stickyOffsetHeight: 0,
            stickyAreaWidth: 0,
            dummyTop: 0,
        };
    },
    mounted () {
        if (this.eDisabled) {
            return;
        }

        this.$refs.sticky.style.setProperty('z-index', this.$root.appConfig.zIndex + this.zIndex, 'important');

        this.stickyAreaElement = this.$el.closest(`[data-sticky-area="${this.stickyArea}"]`);

        sticky.bus.$on('possible-resize', this.onPossibleResize);
        this.onPossibleResize();
        this.$nextTick(this.processScroll); // awaits onPossibleResize to be done
    },
    destroyed () {
        sticky.bus.$off('possible-resize', this.onPossibleResize);
        sticky.stickyRefresh();
    },
    computed: {
        eDisabled () {
            return this.disabled;
        },
        fixedTop () {
            return Math.floor(this.$root.appConfig.fixedTopFn() + this.addFixedTop + this.forceRecompute + this.chatHeaderBottom);
        },
        chatHeaderBottom () {
            return this.$root.appConfig.mode === 'chat' ? this.dimensionsTopBorder + this.dimensionsChatHeaderHeight : 0;
        },
        ...mapState('dimensions', {
            dimensionsTop: 'top',
            dimensionsHeight: 'height',
            dimensionsWidth: 'width',
            dimensionsTopBorder: 'topBorder',
            dimensionsWindowHeight: 'windowHeight',
            dimensionsChatHeaderHeight: 'chatHeaderHeight',
        }),
    },
    watch: {
        dimensionsTop: 'processScroll',
        dimensionsHeight: 'onPossibleResize',
        dimensionsWindowHeight: 'onPossibleResize',
        dimensionsWidth: 'onPossibleResize',
        fixed () {
            this.$emit('fixed', this.fixed);
        },
    },
    methods: {
        onPossibleResize () {
            this.forceRecompute = Math.random();

            this.$nextTick(() => { // awaits markup to be changed
                if (this.eDisabled || !this.$refs.dummy || !this.$refs.sticky) {
                    return;
                }

                this.stickyAreaWidth = this.stickyAreaElement.offsetWidth;
                this.stickyAreaBottom = this.stickyAreaElement.getBoundingClientRect().bottom + this.dimensionsTop;
                this.dummyTop = this.$refs.dummy.getBoundingClientRect().top + this.dimensionsTop;

                if (this.$refs.sticky.offsetHeight >= this.dimensionsWindowHeight - this.fixedTop &&
                    this.stickyArea !== 'sidenotes'
                ) {
                    this.$refs.sticky.style.setProperty('height', this.dimensionsWindowHeight - this.fixedTop + 'px', 'important');
                } else {
                    this.$refs.sticky.style.removeProperty('height');
                }
                this.stickyOffsetHeight = this.$refs.sticky.offsetHeight;

                this.processScroll();
            });
        },
        processScroll () {
            if (this.eDisabled || !this.$refs.dummy || !this.$refs.sticky) {
                return;
            }

            const onBottom = this.stickyAreaBottom < this.stickyOffsetHeight + this.fixedTop + this.dimensionsTop;
            const fixed = this.dummyTop - this.dimensionsTop <= this.fixedTop;

            if (fixed) {
                this.$refs.dummy.style.setProperty('min-height', this.stickyOffsetHeight + 'px', 'important');
                this.$refs.sticky.style.setProperty('width', this.stickyAreaWidth + 'px', 'important');
            } else {
                this.$refs.sticky.style.removeProperty('width');
                this.$refs.dummy.style.removeProperty('min-height');
            }

            if (fixed && !onBottom) {
                this.$refs.sticky.style.setProperty('top', this.fixedTop + 'px', 'important');
            } else {
                this.$refs.sticky.style.removeProperty('top');
            }

            this.fixed = fixed;
            this.onBottom = onBottom;
        },
    },
};
</script>
